import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { useTranslation } from "@/language"

/**
 * Inline prompt shown when a user clicks Instagram sharing but has no
 * connected Instagram Business account. Links to Settings → Connected Accounts.
 */
export function ConnectInstagramPrompt() {
  const navigate = useNavigate()
  const { t } = useTranslation("common")

  return (
    <div className="flex flex-col items-center gap-3 py-4 text-center">
      <p className="text-sm text-stone">{t("share.connectInstagramDesc")}</p>
      <Button
        variant="primary"
        size="sm"
        onClick={() => navigate("/settings?section=connected-accounts")}
      >
        {t("share.connectInstagram")}
      </Button>
    </div>
  )
}
